import { connect } from 'react-redux';
import UserStatusDropdown from '../components/user-status-dropdown';
import { getReferenceData } from './reference-data-actions';

const mapStateToProps = state => ({
  data: state.referenceData.data,
  loadingState: state.referenceData.loadingState,
  errorState: state.referenceData.errorState,
  serviceCenterId: state.navigation.navigationSelf.serviceCenterId,
});

const mapDispatchToProps = { getReferenceData };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(UserStatusDropdown);
